
import * as React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown } from "lucide-react";
import { NavigationItem } from "./types";

interface NavDropdownProps {
  items: NavigationItem[];
  trigger: string;
}

export const NavDropdown = ({ items, trigger }: NavDropdownProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const triggerRef = React.useRef<HTMLButtonElement>(null);
  
  const handleMouseLeave = () => {
    setIsOpen(false);
    if (triggerRef.current) {
      triggerRef.current.blur();
    }
  };

  const handleNavClick = (itemTitle: string) => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'navigation_click', {
        event_category: 'engagement',
        event_label: `${trigger} - ${itemTitle}`,
        navigation_section: trigger,
        item_clicked: itemTitle
      });
    }
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <div onMouseEnter={() => setIsOpen(true)} onMouseLeave={handleMouseLeave}>
        <PopoverTrigger ref={triggerRef} className="flex items-center gap-2 px-4 py-2 text-white hover:text-racing-accent transition-colors group outline-none focus:outline-none">
          <span>{trigger}</span>
          <ChevronDown className="h-4 w-4 transition-transform group-data-[state=open]:rotate-180" />
        </PopoverTrigger>
        <PopoverContent className="w-[425px] bg-[#121212] border-0 p-4" align="start" onMouseEnter={() => setIsOpen(true)} onMouseLeave={handleMouseLeave}>
          <div className="grid gap-4">
            {items.map(option => {
              const Icon = option.icon;
              return (
                <a
                  key={option.title}
                  href={option.href}
                  onClick={() => handleNavClick(option.title)}
                  className="group flex items-center p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg hover:shadow-[#f94933]/10"
                >
                  <div className="h-10 w-10 rounded-full bg-[#f94933]/10 flex items-center justify-center group-hover:bg-[#f94933]/20 transition-colors">
                    <Icon className="h-5 w-5 text-[#f94933]" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-white group-hover:text-[#f94933] transition-colors">
                      {option.title}
                    </h3>
                    {option.description && (
                      <p className="text-sm text-white">{option.description}</p>
                    )}
                  </div>
                  <span className="ml-auto text-[#f94933] opacity-0 group-hover:opacity-100 transition-opacity">
                    →
                  </span>
                </a>
              );
            })}
          </div>
        </PopoverContent>
      </div>
    </Popover>
  );
};
